var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SafeLink',{staticClass:"d-flex footer base",attrs:{"to":_vm.link}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.$vars.basetext}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }